import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import ScrollMagic from 'scrollmagic';


import Nav from './Nav';
import Hero from './Hero';
import BigCard from './BigCard';
import Feature from './Feature';
import Details from './Details';
import Details2 from './Details2';
import Model from './Model';
import Gallery from './Gallery';
import Footer from './Footer';


export default class Home extends Component {

    render() {

        return (
          <div>
            <Nav />
            <Hero />
            <BigCard />
            <Feature />
            <Model />
            <Details />
            <Details2 />
            <Gallery />
            <Footer />
          </div>
        );
    }
}
